import { Policy } from "@mui/icons-material"
import { refundPolicy } from "../../data/shmoozPolicies"
import { lastUpdatedPolicyDate, companyName, companyEmail, companyAddress, companyPhone } from "../../app/store/constant"
import { H3, H2, H5, Body2, H6 } from "../../themes/typography"
import "../../styles/saas-pages/TermsAndConditions.css"

export default function RefundPolicy() {
    return (
        <div className="page-view">
            <div className="page-wrapper">

                <div className="terms-container">
                    <div className="terms-wrapper">

                        <div className="terms-icon-container">
                            <Policy color="tertiary" sx={{ fontSize: '3rem' }} />
                        </div>

                        <div className="content-container">

                            <header className="terms-header">
                                <H2 fontWeight={700}>
                                    Refund & Cancellation Policy
                                </H2>

                                <Body2 color="var(--secondary-color)">
                                    {`Last updated: ${lastUpdatedPolicyDate}`}
                                </Body2>

                                <H3 color="var(--tertiary-color)" fontWeight={600}>
                                    {companyName}
                                </H3>
                            </header>

                            <main className="terms-content">
                                <section className="terms-section">
                                    <Body2>
                                        This Refund & Cancellation Policy ("Policy") outlines the rules and conditions regarding ticket purchases and event cancellations on the Shmooz platform. By purchasing tickets or creating events on Shmooz, you agree to the terms below.
                                    </Body2>
                                </section>

                                {refundPolicy.map((term) => (
                                    <section className="terms-section" key={term.id}>
                                        <H5 color="var(--secondary-color)" fontWeight={700}>
                                            {term.id}. {term.title}
                                        </H5>

                                        {term.type === "text" && typeof term.content === "string" && (
                                            <Body2 dangerouslySetInnerHTML={{ __html: term.content }} />
                                        )}

                                        {term.type === "text" && Array.isArray(term.content) && (
                                            <>
                                                {term.content.map((point, index) => (
                                                    <Body2 key={index}>
                                                        {point}
                                                    </Body2>
                                                ))}
                                            </>
                                        )}

                                        {term.type === "list" && Array.isArray(term.content) && (
                                            <ul className="terms-list">
                                                {term.content.map((point, index) => (
                                                    <Body2 key={index}>
                                                        <li>{point}</li>
                                                    </Body2>
                                                ))}
                                            </ul>
                                        )}

                                        {term.type === "contact" && term.contact && (
                                            <div className="contact-info">
                                                <Body2>
                                                    {term.contact.name}
                                                </Body2>
                                                {term.contact.address && (
                                                    <Body2>
                                                        Address : {companyAddress}
                                                    </Body2>
                                                )}
                                                {term.contact.email && (
                                                    <Body2>
                                                        Email : <a href={`mailto:${companyEmail}`}>{companyEmail}</a>
                                                    </Body2>
                                                )}
                                                {term.contact.phone && (
                                                    <Body2>
                                                        Phone : <a href={`tel:${companyPhone}`}>{companyPhone}</a>
                                                    </Body2>
                                                )}
                                            </div>
                                        )}

                                        {term.type === "subsections" && term.subsections && (
                                            <div className="subsections-container">
                                                {term.subsections.map((subsection) => (
                                                    <div key={subsection.id} className="subsection">
                                                        <H6 fontWeight={700}>
                                                            {subsection.title}
                                                        </H6>

                                                        {subsection.content && (
                                                            <Body2 dangerouslySetInnerHTML={{ __html: subsection.content }} />
                                                        )}

                                                        {subsection.nestedSections && (
                                                            <div className="nested-sections">
                                                                {subsection.nestedSections.map((nested) => (
                                                                    <div key={nested.id} className="nested-section">
                                                                        <Body2 fontWeight={600} color="var(--secondary-color)">
                                                                            {nested.title}
                                                                        </Body2>

                                                                        {nested.content && (
                                                                            <Body2 dangerouslySetInnerHTML={{ __html: nested.content }} />
                                                                        )}

                                                                        {nested.steps && (
                                                                            <ul className="terms-list">
                                                                                {nested.steps.map((step, index) => (
                                                                                    <Body2 key={index}>
                                                                                        <li dangerouslySetInnerHTML={{ __html: step }} />
                                                                                    </Body2>
                                                                                ))}
                                                                            </ul>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </section>
                                ))}
                            </main>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}